import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import ArchivContainer from "../../utils/ArchivContainer";
import Timeformat from "../../utils/Timeformat";
import DesignPreviewContainer from "../../utils/DesignPreviewContainer";
import StaticFunctions from "../../utils/StaticFunctions";

class DesignMedium extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        data: PropTypes.array.isRequired
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {};

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

    }

    componentWillMount() {

        if (this.props.willMount) this.props.willMount();

    }

    getItems() {

        const items = [];

        this.props.data.forEach((item) => {
            if (item !== null) {
                items.push(this.renderItem(item));
            }
        });

        if (items.length > 0) return items;
/*
        if (this.props.data.length > 0) {
            return this.props.data.map(
                (item) => this.renderItem(item)
            );
        }
*/
        return this.translate('noDesignFound');

    }

    renderItem(item) {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const classes = ['archivContainer', 'col-md-4'].join(' ').trim();
        const dateInserted = (item.date_inserted) ? Timeformat.fromUnix(item.date_inserted).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

        return (
            <div key={'design-medium-' + item.id} className={classes}>
                <div className="archivBox">
                    <div className="clearfix">
                        <div className="archivBlock fll">
                            <ArchivContainer
                                key={'design-' + item.id + '-' + item.stitches}
                                archivKey={'medium-design'}
                                archivId={item.id}
                                classes={'bordered bgContain bgWhite noMargin'}
                                useBootstrap={false}
                                content={<DesignPreviewContainer baseData={this.props.baseData} designId={item.id} designStitches={item.stitches}/>}
                                onClick={this.props.onClick}
                            />
                        </div>

                        <div className="archivBlock paddingBox5 flr">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="text-left">{this.translate('designId')}</td>
                                        <td className="text-left">{item.id}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">{this.translate('designName')}</td>
                                        <td className="text-left">{(item.name) ? item.name : '-'}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">{this.translate('designStitches')}</td>
                                        <td className="text-left">{StaticFunctions.formatedNumber(item.stitches)}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-left">{this.translate('dateInserted')}</td>
                                        <td className="text-left">{dateInserted}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );

    }

    render() {

        return this.getItems();

    }

}

export default DesignMedium;
